import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";
import SFLandingPageComponent from "./component";
import { getLandingPageData, sendOTP, setSsrStatus, verifyOtp } from "./actions";

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getLandingPageDataConnect: getLandingPageData,
            setSSRStatusConnect: setSsrStatus,
            sendOTPConnect: sendOTP,
            verifyOtpConnect: verifyOtp
        },
        dispatch
    );

const mapStateToProps = ({
    sfLandingPageData: {
        sfLandingPageData: { cms, faqList, cmsImageGallery, jsonContent },
        isSsr
    },
    user: { isLoggedIn, mobile }
}) => ({
    cms,
    faqList,
    cmsImageGallery,
    jsonContent,
    isSsr,
    isLoggedIn,
    mobile
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(SFLandingPageComponent)
);
